
export default {
	name: "AboutSectionHeader",
	props: {
		eyebrow: {
			type: String,
			default: "",
		},
		description: {
			type: String,
			default: "",
		},
		descriptionClass: {
			type: String,
			default: "",
		},
	},
};
